import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DistributionListResult, SiteSearchResult, SnrProfileResult } from '../models/generated/ziroModels';

@Injectable({ providedIn: 'root' })
export class SearchResource {
  private http = inject(HttpClient);

  limit = 100;

  searchSnrProfiles(
    query: string,
    searchParam: 'q' | 'name' = 'q',
    cucmServerId?: number,
  ): Observable<SnrProfileResult[]> {
    let queryParams = `${searchParam}=${encodeURIComponent(query)}`;

    if (cucmServerId) {
      queryParams += `&cucmServerId=${encodeURIComponent(cucmServerId.toString())}`;
    }

    return this.http.get<SnrProfileResult[]>(
      `/services/cisco/macs/snr-profiles/search?${queryParams}&limit=${this.limit}`,
    );
  }

  searchDistributionLists(query: string, cucmServerId?: number): Observable<DistributionListResult[]> {
    let queryParams = `q=${encodeURIComponent(query)}`;

    if (cucmServerId) {
      queryParams += `&cucmServerId=${encodeURIComponent(cucmServerId.toString())}`;
    }

    return this.http.get<DistributionListResult[]>(
      `/services/cisco/macs/distribution-lists/search?${queryParams}&limit=${this.limit}`,
    );
  }

  findByDevicePool(devicePool: string): Observable<SiteSearchResult[]> {
    return this.http.get<SiteSearchResult[]>(
      `/services/cisco/admin/sites/search?devicePool=${encodeURIComponent(devicePool)}`,
    );
  }
}
